import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api } from '@.api';
import { Layout } from '@.layout';
import { Table2 } from '@.partials';
import { LinkHelper } from '@.services';
import { Button } from '@.ui';
import { RolesResponseType } from '@/Services/api/methods';
import { PermissionProps, Request } from '@/Types';

export * from './RolesAction';

/**
 * @todo full remove all roles page?
 */
export const Roles: React.FC<PermissionProps> = (props) => {
    const navigator = useNavigate();

    const get = useCallback((q?: Request.All) => Api.roles().getAll(q), []);

    const handleDelete = useCallback((id: number) => Api.roles().delete(id), []);
    const handleRestore = useCallback((id: number) => Api.roles().restore(id), []);

    const getData = useCallback((d: RolesResponseType) => d.roles, []);

    return (
        <Layout name="settings" breadcrumbs={[{ name: 'user roles', current: true }]}>
            <h1>
                User roles
                <Button color="brown" text="Add role" onClick={() => navigator(LinkHelper.settingsRolesAdd)} disabled={!props.permissions?.create} />
            </h1>
            <Table2 get={get} getData={getData} export="roles">
                {{
                    items: [
                        (item) => ({
                            link: LinkHelper.settingsRolesEditId(item.id),
                            disabled: !!item.deleted_at || !props.permissions?.update,
                            name: 'Name',
                            max: 50,
                            sort: 'name',
                            content: item.name,
                        }),
                    ],
                    actions: [
                        (item) => ({
                            type: 'edit',
                            link: LinkHelper.settingsRolesEditId(item.id),
                            disabled: !!item.deleted_at || !props.permissions?.update,
                        }),
                        (item) => ({
                            type: item.deleted_at ? 'restore' : 'destroy',
                            lonClick: item.deleted_at ? () => handleRestore(item.id) : () => handleDelete(item.id),
                            disabled: !props.permissions?.delete,
                        }),
                    ],
                }}
            </Table2>
        </Layout>
    );
};
